// dagWorkerPrompt.js — FASE-12 E4-T01. Monta as `messages` de UMA task do executor
// DAG (e do thinker). Antes o baseRunTask montava um array com só a mensagem do
// user — o caminho DAG dá `return` ANTES do turno único que injeta a CODING DOCTRINE
// (agent-rules), então cada worker de task rodava SEM a doutrina que os turnos
// manuais recebem. Aqui a doutrina entra como system (quando não-vazia) e o corpo
// da task é montado num lugar PURO/testável (tira os ternários do SessionWorkspace,
// que vive no teto do ratchet dp-loc). A constituição (LEI) continua vindo do Worker.

/**
 * Corpo do prompt de uma task do DAG: decisões do usuário (do texto de aprovação) +
 * nome/goal + acceptance + nota do Thinker, cada parte só quando presente.
 * @param {{ name?: string, goal?: string, id?: string, acceptance?: string, thinkerNote?: string }} task
 * @param {string} [userDecisions]
 * @returns {string}
 */
export function buildDagTaskBody(task = {}, userDecisions = '') {
  const decisions = userDecisions ? `${userDecisions}\n\n` : '';
  const head = task.name || task.goal || task.id || '';
  const acceptance = task.acceptance ? `\n\nAcceptance: ${task.acceptance}` : '';
  const thinker = task.thinkerNote ? `\n\nPlano (Thinker): ${task.thinkerNote}` : '';
  return `${decisions}${head}${acceptance}${thinker}`;
}

/**
 * O array de messages do worker de uma task: a CODING DOCTRINE (quando injetável)
 * como system + o corpo da task como user. doctrine vazio ⇒ só a mensagem do user
 * (byte-idêntico ao comportamento antigo do baseRunTask).
 *
 * RCA lentidão fix G — `planDigest` (planContextDigest.js) entra no MESMO bloco
 * system, depois da doutrina: é IDÊNTICO em todas as tasks do run (prefixo estável
 * ⇒ prompt-cache friendly) e mata o cold-start (o worker nasce sabendo o que o
 * planner já leu/decidiu em vez de re-explorar do zero). Vazio ⇒ byte-idêntico.
 * @param {object} task
 * @param {{ userDecisions?: string, doctrine?: string, planDigest?: string }} [opts]
 * @returns {Array<{role: string, content: string}>}
 */
export function buildDagWorkerMessages(task = {}, { userDecisions = '', doctrine = '', planDigest = '' } = {}) {
  const body = buildDagTaskBody(task, userDecisions);
  const sysContent = [doctrine, planDigest].map((s) => (s || '').trim()).filter(Boolean).join('\n\n');
  const sys = sysContent ? [{ role: 'system', content: sysContent }] : [];
  return [...sys, { role: 'user', content: body }];
}
